import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';

const FullScreenDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});

const FullScreenImage = styled('img')({
    maxWidth: '100vw',
    maxHeight: '100vh',
    objectFit: 'contain'
});

const ExitButton = styled(IconButton)({
    position: 'absolute',
    top: '12px',
    right: '12px',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }
});

type FullScreenImageViewProps = {
    open: boolean;
    src: string;
    alt: string;
    onClose: () => void;
};

export function FullScreenImageView({ open, src, alt, onClose }: FullScreenImageViewProps) {
    return (
        <FullScreenDialog fullScreen open={open} onClose={onClose} data-testid="full-screen-image">
            <ExitButton
                aria-label={Translate('image-processing/modal/footer/button-label/close')}
                onClick={onClose}
            >
                <FullscreenExitIcon />
            </ExitButton>
            <FullScreenImage src={src} alt={alt} onDoubleClick={onClose} />
        </FullScreenDialog>
    );
}
